import React from 'react';

export default (
    <svg
        width="28px"
        height="40px"
        viewBox="0 0 28 40"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <g
            id="Events-&amp;-Webinars-Marketing-mocks-(may-2019)"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
        >
            <g
                id="Events-Calendar-Lander-Zero-state"
                transform="translate(-578.000000, -353.000000)"
            >
                <g id="Group-5" transform="translate(578.000000, 353.000000)">
                    <g id="Group-11">
                        <path
                            d="M7.09197442,19.6458665 C11.178392,16.0112874 13.0549399,13.018947 12.7216182,10.6688453 C12.3882965,8.31874365 14.5977768,5.63044878 19.350059,2.60396072 L20.3260522,7.77319589 C19.2935715,10.8928239 18.0261659,13.2580018 16.5238352,14.8687296 C15.0215045,16.4794575 12.5512742,18.4568201 9.11314426,20.8008176 L7.09197442,19.6458665 Z"
                            id="Path-15-Copy"
                            fill="#E7ECF7"
                            transform="translate(13.709013, 11.702389) scale(-1, 1) rotate(-20.000000) translate(-13.709013, -11.702389) "
                        ></path>
                        <path
                            d="M8.91814591,23.1413779 C5.25244058,19.7015136 3.36203597,16.9444141 3.2469321,14.8700793 C3.07427629,11.758577 4.66473555,5.91308658 6.082539,5.91308658 C7.50034245,5.91308658 8.09551925,10.4295633 8.91814591,14.8700793 C9.46656367,17.8304233 9.46656367,20.5875228 8.91814591,23.1413779 Z"
                            id="Path-12"
                            fill="#E4ECFF"
                            transform="translate(6.281737, 14.527232) rotate(-20.000000) translate(-6.281737, -14.527232) "
                        ></path>
                        <path
                            d="M21.3500737,24.1093371 C16.4223418,19.4851987 13.8811099,15.7788867 13.7263782,12.9904012 C13.4942805,8.80767303 15.6323021,0.949701005 17.538226,0.949701005 C19.4441498,0.949701005 20.2442337,7.02110731 21.3500737,12.9904012 C22.0873004,16.9699305 22.0873004,20.6762425 21.3500737,24.1093371 Z"
                            id="Path-12-Copy-2"
                            fill="#E4ECFF"
                            transform="translate(17.806004, 12.529519) scale(-1, 1) rotate(-20.000000) translate(-17.806004, -12.529519) "
                        ></path>
                        <path
                            d="M13.2918978,22.9067761 C9.48747676,18.7223551 7.52771433,15.5929772 7.41261045,13.5186423 C7.34193776,12.2450203 5.73933279,1.79727678 6.5183925,0.140959343 C6.84491694,-0.553246899 8.34486109,1.31670274 11.018225,5.75080827 C11.961412,7.83701266 12.244258,10.6553555 11.866763,14.2058368 C11.4892681,17.7563181 11.964313,20.6566312 13.2918978,22.9067761 Z"
                            id="Path-12-Copy"
                            fill="#D2DCF1"
                        ></path>
                        <path
                            d="M18.6704412,27.323659 C13.5216224,22.3320795 10.8807457,18.6384563 10.7478113,16.2427894 C10.6661908,14.7718724 9.94791978,2.94411897 10.8476625,1.03122389 C11.2247683,0.229479208 12.9570665,2.38909993 16.0445572,7.51008605 C17.1338519,9.91946122 17.4605132,13.1743893 17.024541,17.2748703 C16.5885689,21.3753513 17.1372023,24.7249475 18.6704412,27.323659 Z"
                            id="Path-12-Copy-3"
                            fill="#F2F5FE"
                            transform="translate(14.534792, 14.096044) scale(-1, 1) rotate(-4.000000) translate(-14.534792, -14.096044) "
                        ></path>
                        <path
                            d="M13.7090133,21.3001263 C17.7954308,17.6655471 19.6719788,14.6732067 19.3386571,12.3231051 C19.0053354,9.97300337 21.2148157,7.28470849 25.9670979,4.25822044 L26.943091,9.4274556 C25.9106104,12.5470836 24.6432047,14.9122615 23.1408741,16.5229894 C21.6385434,18.1337172 19.1683131,20.1110799 15.7301831,22.4550773 L13.7090133,21.3001263 Z"
                            id="Path-15"
                            fill="#D2DCF1"
                        ></path>
                        <path
                            d="M1.62861869,19.8511166 L26.0967742,19.8511166 C26.6490589,19.8511166 27.0967742,20.2988319 27.0967742,20.8511166 L27.0967742,29.7766749 C27.0967742,35.2584094 22.6529504,39.7022333 17.1712159,39.7022333 L10.554177,39.7022333 C5.07244252,39.7022333 0.628618693,35.2584094 0.628618693,29.7766749 L0.628618693,20.8511166 C0.628618693,20.2988319 1.07633394,19.8511166 1.62861869,19.8511166 Z"
                            id="Rectangle-Copy"
                            fill="#DFE5F2"
                        ></path>
                        <rect
                            id="Rectangle"
                            fill="#D6DFF1"
                            x="0.628618693"
                            y="24.8138958"
                            width="26.4681555"
                            height="1.65425972"
                        ></rect>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);
